import { Injectable } from '@angular/core';
import { BpmButtonDef } from '../models/bpm-button-def';

@Injectable()
export class BpmButtonDefBuilderService {
  buttonDefs: BpmButtonDef[] = [];

  constructor() {}

  convertToBpmButtonDefs(actions: string[]): BpmButtonDef[] {
    const btnDefs: BpmButtonDef[] = actions.map((action) => {
      const mappingDef = this.buttonDefs.find((x) => x.action === action) ?? {
        displayName: action,
        action,
        priority: 2,
        order: 99,
      };
      return mappingDef;
    });

    return btnDefs;
  }
}
